// HP-6342: START - Apartment First Experiment (import)
import Filter, { APARTMENT_DEFAULT_PROPERTY_TYPES } from 'app/shared/models/Filter';
// HP-6342: END
import CONSTANTS from 'app/shared/constants/DispatchConstants';

interface Action {
  type: string;
  payload: object;
}

const initFilter = new Filter();
const initState = initFilter;
const filter = (state = initState, action: Action = {} as Action) => {
  const { type, payload } = action;

  if (type === CONSTANTS.UPDATE_MWEB_FILTER) {
    return {
      ...state,
      ...payload,
    };
  }

  // HP-6342: START - Apartment First Experiment
  if (type === CONSTANTS.INIT_FILTER_WITH_EXPERIMENT_STATE) {
    const { isApartmentFirstExperiment } = payload as { isApartmentFirstExperiment: boolean };
    const newFilter = new Filter();
    if (isApartmentFirstExperiment) {
      newFilter.propertyTypes = APARTMENT_DEFAULT_PROPERTY_TYPES;
    }
    return newFilter;
  }
  // HP-6342: END

  return state;
};

export default filter;
